import { luxonDTValiType } from "@dmca/utils/luxon";
import { ContactInfo } from "@dmca/utils/types";
import {
    object,
    pipe,
    string,
    uuid,
    enum_,
    type InferOutput,
    nullable,
    boolean,
    optional,
    transform,
} from "valibot";

export enum CellHelpStatusEnum {
    CLEAR = "CLEAR",
    FORKLIFT = "FORKLIFT",
    SUPERVISOR = "SUPERVISOR",
    MAINTENANCE = "MAINTENANCE",
    ENGINEERING = "ENGINEERING",
    PROCUREMENT = "PROCUREMENT",
    SEEN = "SEEN",
}

export const CellHelpStatusColorMap = {
    CLEAR: "#a9a9a9",
    FORKLIFT: "#f0f",
    SUPERVISOR: "#ff0",
    MAINTENANCE: "#f00",
    ENGINEERING: "#00f",
    PROCUREMENT: "#ff6600",
    SEEN: "#0f0",
} as const satisfies { [P in CellHelpStatusEnum]: string };

export const ICellHelpStatusDBModel = object({
    cellId: string(),
    state: enum_(CellHelpStatusEnum),
    createdAt: luxonDTValiType(),
    id: pipe(string(), uuid()),
    triggeredBy: string(),
});
export type ICellHelpStatusDBModel = InferOutput<typeof ICellHelpStatusDBModel>;

export const ICellHelpStatus = ICellHelpStatusDBModel;
export type ICellHelpStatus = InferOutput<typeof ICellHelpStatus>;

export const ICellHelpStatusDBToOutputTransform = pipe(
    ICellHelpStatusDBModel,
    ICellHelpStatus
);

export const ICellHelpStatusNotificationDBModel = object({
    cellId: nullable(string()),
    plantId: nullable(string()),
    allDevices: boolean(),
    state: enum_(CellHelpStatusEnum),
    contact: ContactInfo,
    id: string(),
});
export type ICellHelpStatusNotificationDBModel = InferOutput<
    typeof ICellHelpStatusNotificationDBModel
>;

export const ICellHelpStatusNotification = object({
    cellId: optional(string()),
    plantId: optional(string()),
    allDevices: boolean(),
    state: enum_(CellHelpStatusEnum),
    contact: ContactInfo,
    id: string(),
});
export type ICellHelpStatusNotification = InferOutput<
    typeof ICellHelpStatusNotification
>;

export const ICellHelpStatusNotificationDBToOutputTransform = pipe(
    ICellHelpStatusNotificationDBModel,
    transform(
        (val) =>
            ({
                ...val,
                cellId: val.cellId || undefined,
                plantId: val.plantId || undefined,
            } satisfies ICellHelpStatusNotification)
    )
);
